const APPROVED = "AL135";

export function registerGiwlDecisionPageOnloadHandler(coverage_amount, payment_amount, policyNumber, interactionCode) {
    window.onload = function () {
        const applicationSuccess = interactionCode === APPROVED;
        if (applicationSuccess) {
            const coverageAmountString = coverage_amount.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            });

            if (document.getElementById("dynamicJoinClubLink") && sessionStorage.getItem("ipObj")) {
                var zip = JSON.parse(sessionStorage.getItem("ipObj")).zipCode;
                document.getElementById("dynamicJoinClubLink").href =
                    "https://michigan.aaa.com/Partners/Join.aspx?cid=PartnerJoin_AAALife&amp;zipcode=" + zip;
            }
            document.getElementById("coverageAmt").innerHTML = coverageAmountString;
            document.getElementById("paymentAmt").innerHTML = payment_amount.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        }

        let submissionData = {};
        if (applicationSuccess) {
            submissionData = {
                attr: {
                    itc: interactionCode,
                },
                current: {
                    policyNumber: policyNumber,
                    coverageAmount: coverage_amount.toString(),
                    premiumAmount: payment_amount.toString() + ".00",
                },
            };
        } else {
            submissionData = {
                attr: {
                    itc: interactionCode,
                },
                current: {
                    policyNumber: policyNumber,
                },
            };
        }

        $.ajax({
            url: aaalife.ctx + "restservices/aggregate",
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify(submissionData),
            type: "POST",
            async: false,
            timeout: 30000,
        });

        const hasPolicyNumber = policyNumber.length >= 4;
        if (hasPolicyNumber) {
            if (applicationSuccess) {
                const coverageAmountString = coverage_amount.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                });

                dataLayer.push({
                    event: "ecPurchase",
                    PCIN: policyNumber, // Policy Number
                    ecommerce: {
                        purchase: {
                            actionField: {
                                id: null, // Transaction ID
                                revenue: payment_amount.toString() + ".00", // monthly premium
                            },
                            products: [
                                {
                                    name: "GIWL", // Name or ID is required (GIWL|ET)
                                    id: "GIWL",
                                    price: (payment_amount * 12).toString() + ".00", // monthly premium x 12
                                    variant: coverageAmountString, // For GIWL = “<CoverageAmount>”, For ET = “<TermLength>_<CoverageAmount>”
                                    quantity: 1,
                                },
                            ],
                        },
                    },
                });
            } else {
                aaalife.data.user.PCIN = policyNumber;
                dataLayer.push({
                    event: "collectPCIN",
                    user: aaalife.data.user,
                });
            }
        }
        sessionStorage.clear();
    };
}

// Check to see if we have decision data left from the GIWL confirmation page
if (window.giwlDecisionData) {
    const { coverage_amount, payment_amount, policyNumber, interactionCode } = window.giwlDecisionData;
    registerGiwlDecisionPageOnloadHandler(coverage_amount, payment_amount, policyNumber, interactionCode);
}
